// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { exposeAuthVaultDebug } from './app/core/auth/auth-vault.debug';

// Dev-only console surface for the native-token-custody walking skeleton
// (no-op in production builds; nothing in the app consumes it).
exposeAuthVaultDebug();

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error('Error bootstrapping the application:', err);
});
